/**
 * 現在の表示できるお支払い情報を担う
 */
import { useState, useEffect } from 'react';
import { useFetch } from '../common/useFetch';
import { SubscriptionState } from '../App/useSubscription';

const initialState: PaymentMethod = {
  brand: '',
  expiryMonth: 0,
  expiryYear: 0,
  maskedNumber: '',
}

export const usePaymentMethod = (
  subscription: SubscriptionState,
  token: string
): UsePaymentMethod => {

  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(initialState);
  const [paymentMethodState, getPaymentMethod] = 
    useFetch<PaymentMethod>('getPaymentMethod', token);

  useEffect(() => {
    if (!subscription?.subscriptionContractId) return;
    getPaymentMethod({
      subscriptionContractId: subscription.subscriptionContractId
    })
  }, [subscription])

  // リクエスト取得後の挙動
  useEffect(() => {
    if (!paymentMethodState?.data) return;
    const paymentMethodData = paymentMethodState.data ?? initialState;
    setPaymentMethod(paymentMethodData);
  }, [paymentMethodState]);

  return {
    paymentMethod, 
    loadingPaymentMethod: paymentMethodState.loading,
  }
};

// types

type UsePaymentMethod = {
  paymentMethod: PaymentMethod,
  loadingPaymentMethod: boolean
}

export type PaymentMethod = {
  brand: string;
  expiryMonth: number;
  expiryYear: number;
  maskedNumber: string;
};
